<template>
  <div>
    <h1>Associar tarefas à equipe {{ this.equipeSelecionada.nome || this.equipeSelecionada.name }}</h1>

    <div
      class="container-dados-equipe"
      v-if="!loadingEquipe && (listaDadosAssociados.length || listaDadosDisponiveis.length)"
    >
      <label>Equipe: {{ this.equipeSelecionada.nome || this.equipeSelecionada.name }}</label>
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Tarefas"
      tituloDisponiveis="Tarefas"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="tarefasParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingEquipe" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EquipeTarefaAssociacaoPage',

  data() {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created() {
    await this.listarTodasTarefas()
    await this.recuperarEquipeComTarefas(this.$route.params.equipe)

    this.atualizarListaDeDadosAssociadosENaoAssociados()
  },

  computed: {
    ...mapGetters('appCtrlEquipes', [
      'loadingEquipe',
      'listaDeTodasTarefas',
      'equipeSelecionadaComTarefas'
    ]),

    equipeSelecionada() {
      return this.equipeSelecionadaComTarefas
    },

    tarefasAssociadas() {
      if (!this.equipeSelecionadaComTarefas?.tarefas) return []

      return this.equipeSelecionadaComTarefas.tarefas.map(tarefa => ({
        id: tarefa.id,
        descricao: tarefa.tarefa || tarefa.name,
        selecionado: false
      }))
    },

    tarefasDisponiveis() {
      const associadosIds = this.equipeSelecionadaComTarefas?.tarefas?.map(t => t.id) || []
      const todasTarefas = this.listaDeTodasTarefas || []

      return todasTarefas
        .filter(tarefa => !associadosIds.includes(tarefa.id))
        .map(tarefa => ({
          id: tarefa.id,
          descricao: tarefa.tarefa || tarefa.name,
          selecionado: false
        }))
    }
  },

  methods: {
    ...mapActions('appCtrlEquipes', [
      'listarTodasTarefas',
      'recuperarEquipeComTarefas',
      'associarTarefasAEquipe'
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados() {
      this.listaDadosAssociados = this.tarefasAssociadas
      this.listaDadosDisponiveis = this.tarefasDisponiveis
    },

    tarefasParaAssociar(value) {
      const listaIdsAssociados = value.listaAssociados.map(tarefa => tarefa.id)

      const payload = {
        tarefas: listaIdsAssociados,
        equipeId: this.$route.params.equipe
      }

      this.associarTarefasAEquipe(payload)
    }
  }
}
</script>

<style scoped>
.container-dados-equipe {
  margin-bottom: 20px;
}
</style>
